import type { RGBA } from "models-webgl2";
import { Vec2 } from "utils/math/vec2";
import { Webgl2 } from "../../../webgl2";
import { Webgl2Component } from "../../webgl2-component";

export class CropUnitComponent extends Webgl2Component {
  constructor(size: Vec2, private readonly _color: RGBA = [0, 0.6, 0.63, 1]) {
    super();
    this.transform.setSize(size);
  }

  public getRenderData() {
    const material = Webgl2.materials.backgroundColor;
    material.setUniforms({
      u_color: this._color,
    });
    return { material };
  }
}

export default CropUnitComponent;
